// extracted by mini-css-extract-plugin
module.exports = {"FileUploadBlock":"ImportFileIcon_FileUploadBlock__1V1Uy","FileUploadInput":"ImportFileIcon_FileUploadInput__2ubBf"};